module.exports = __webpack_public_path__ + "assets/img/26-l.bba4a71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/26-l.jpg
// module id = MXh8
// module chunks = 0